import React from 'react';
import { ArrowRight, PenTool, FileSearch, ClipboardCheck } from 'lucide-react';
import { DESIGN_ITEMS } from '../mock';

const ICON_MAP = { PenTool, FileSearch, ClipboardCheck };

export default function DesignConsult() {
  return (
    <section id="projektowanie" className="bg-[#f5f5f7] py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">PROJEKTOWANIE I KONSULTACJE</div>
        <h2 className="font-heading font-extrabold text-[36px] md:text-[48px] leading-[1.08] tracking-tight text-[#0f1a2b] max-w-3xl">
          Projektowanie i konsultacje budowlano-elektryczne
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {DESIGN_ITEMS.map((it) => {
            const Icon = ICON_MAP[it.icon] || PenTool;
            return (
              <div key={it.title} className="rounded-2xl bg-white border border-slate-200 p-7 hover-lift">
                <div className="h-11 w-11 rounded-lg bg-[#132a44] flex items-center justify-center mb-6">
                  <Icon className="h-5 w-5 text-[#f5c518]" />
                </div>
                <h3 className="font-heading font-bold text-[19px] tracking-tight text-[#0f1a2b]">{it.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[#0f1a2b]/70">{it.desc}</p>
              </div>
            );
          })}
        </div>

        <a href="#kontakt" className="mt-10 inline-flex items-center gap-2 text-[#0f1a2b] font-semibold text-[15px] group">
          Skonsultuj dokumentację
          <ArrowRight className="h-4 w-4 text-[#f5c518] transition-transform group-hover:translate-x-1" />
        </a>
      </div>
    </section>
  );
}
